//
// Copyright (c) 2026 Comcast
//

import PropTypes from 'prop-types'
import styled from 'styled-components'
import ReactModal from 'react-modal'

import colors from 'components/utils/colors'

const VERTICAL_PADDING = 48

// The app and the Playwright component host render into #application-content,
// the Storybook preview into #storybook-root.
const appElement =
  document.getElementById('application-content') ||
  document.getElementById('storybook-root')

if (appElement) {
  ReactModal.setAppElement(appElement)
}

function ReactModalAdapter ({ className, ...props }) {
  const contentClassName = `${className}__content`
  const overlayClassName = `${className}__overlay`
  return (
    <ReactModal
      portalClassName={className}
      className={contentClassName}
      overlayClassName={overlayClassName}
      {...props}
    />
  )
}

const StyledModal = styled(ReactModalAdapter)`
  &__overlay {
    display: flex;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.35);
    z-index: 9999;
    justify-content: center;
    align-items: ${props => props.alignTop ? 'flex-start' : 'center'};
  }

  &__content {
    position: relative;
    background: #FFFFFF;
    max-height: calc(100% - ${props => props.alignTopPadding * 2}px);
    ${props => props.isModalForm && `
      width: calc(min(70%, 1008px));
      min-width: 704px;
    `}
    ${props => !props.isModalForm && `
      min-width: 424px;
      max-width: 90%;
    `};
    display: flex;
    flex-direction: column;
    padding: 0;
    color: ${colors.secondary20};
    border-radius: 0;
    outline: none;
    // add conditional block of css attributes
    ${props => props.alignTop && `
      top: ${props.alignTopPadding}px;
    `}
  }
`

const Modal = ({
  children, open, closeModal, ignoreOverlayClicks, alignTop, alignTopPadding,
  isModalForm, ...props
}) => {
  const alignTopPadding_ = alignTopPadding ?? VERTICAL_PADDING
  return (
    <StyledModal
      isOpen={open}
      shouldCloseOnOverlayClick={!ignoreOverlayClicks}
      onRequestClose={closeModal}
      alignTop={alignTop}
      alignTopPadding={alignTopPadding_}
      isModalForm={isModalForm}
      {...props}
    >
      {children}
    </StyledModal>
  )
}

Modal.propTypes = {
  children: PropTypes.node,
  open: PropTypes.bool,
  closeModal: PropTypes.func,
  ignoreOverlayClicks: PropTypes.bool,
  alignTop: PropTypes.bool,
  alignTopPadding: PropTypes.number,
  isModalForm: PropTypes.bool,
}

export default Modal
